// extracted by mini-css-extract-plugin
export default {"mainContent":"PageLayout_mainContent__RRrT6","headerWrapper":"PageLayout_headerWrapper__wP7VT","pageContent":"PageLayout_pageContent__XtXQ2"};